export default {
  BASE_URL: '',
  api: [
    {
      name: 'list',
      desc: '供应商列表',
      method: 'GET',
      path: '/erp/sob/support/list'
    },
    {
      name: 'getListIntersection',
      desc: '批量选择供应商列表',
      method: 'POST',
      path: '/erp/sob/support/getListIntersection'
    },
    {
      name: 'saveOrUpdate',
      desc: '供应商保存(新增编辑)',
      method: 'POST',
      path: '/erp/sob/support/saveOrUpdate'
    },
    {
      name: 'getById',
      desc: '供应商详情',
      method: 'GET',
      path: '/erp/sob/support/getById'
    },
    {
      name: 'examine',
      desc: '供应商审核状态变更',
      method: 'POST',
      path: '/erp/sob/support/examine'
    },
    {
      name: 'delete',
      desc: '供应商删除',
      method: 'POST',
      path: '/erp/sob/support/delete'
    },
    {
      name: 'export',
      desc: '供应商列表导出',
      method: 'POST',
      path: '/erp/sob/support/export'
    },
    {
      name: 'billStatusList',
      desc: '供应商审核状态下拉',
      method: 'GET',
      path: '/erp/sob/support/billStatusList'
    },
    {
      name: 'payTypeList',
      desc: '供应商结算方式下拉',
      method: 'GET',
      path: '/erp/sob/support/payTypeList'
    },
    {
      name: 'supportTypeList',
      desc: '供应商类型下拉',
      method: 'GET',
      path: '/erp/sob/support/supportTypeList'
    },
    {
      name: 'supportKindList',
      desc: '供应商商品类型下拉',
      method: 'GET',
      path: '/erp/sob/support/supportKindList'
    },
    {
      name: 'modifyEnableStatusV5',
      desc: '启用禁用',
      method: 'GET',
      path: '/erp/sob/support/modifyEnableStatus'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/api/apis/self/information/supplier.js